<div class="pa-message-content micromate-message-content">
    <div class="micromate-learning-package-introduction" [innerHTML]="responseItemData.text.message | emoji">
    </div>
    <div (click)="navigateToProfile()"
         class="micromate-profile-link">
        <app-icon [icon]="'user-light'" class="micromate-profile-link-icon"></app-icon>
        {{createProfileText(responseItemData.text.buttonText)}}
    </div>
</div>
